import { Provider as AnalyticsProvider } from '@carvana/analytics';
import { AnalyticsProvider as EventableAnalyticsProvider } from '@carvana/eventable-clickstream';
import ThemeProvider, { CarvanaThemeDeprecated } from '@carvana/showroom-theme';
import { ConnectedRouter } from 'connected-react-router';
import React from 'react';
import { Provider } from 'react-redux';
import { ConsentProvider, ConsentKeys } from '@carvana/core-consent';
import { environment, isLocalEnvironment } from './environment';
import initDataDog from './utilities/datadogInit';
import Account from './Account';
import ErrorBoundary from './shared/components/ErrorBoundary';
import AuthGuard from './shared/components/AuthGuard/AuthGuard';
import ScrollToTop from './shared/components/ScrollToTop/ScrollToTop';
import configs from './store/configs';
import store, { history } from './store/configureStore';

import '@carvana/showroom-css-theme/Font.css';
import '@carvana/showroom-css-theme/Reset.css';
import '@carvana/showroom-css-theme/Theme.css';
import '@carvana/showroom-forms/index.css';

import './App.css';

if (!isLocalEnvironment) {
  initDataDog();
}

// Note: This Application also services the `ThirdPartyOptOut` Consent,
// however there is NO `ThirdPartyOptOut` ConsentKey in the ConsentProvider,
// as there is no recorded display verbiage.

export default (
  <Provider store={store}>
    <ThemeProvider theme={CarvanaThemeDeprecated}>
      <ErrorBoundary>
        <EventableAnalyticsProvider environment={environment} projectName="account-ui" track="core">
          <AnalyticsProvider configs={configs} debug>
            <ConsentProvider
              environment={environment}
              track="core"
              projectName="account-ui"
              consentsRequired={[ConsentKeys.Tcpa, ConsentKeys.CreditMonitoring]}
              prefetch
            >
              <ConnectedRouter history={history}>
                <ScrollToTop>
                  <AuthGuard>
                    <Account />
                  </AuthGuard>
                </ScrollToTop>
              </ConnectedRouter>
            </ConsentProvider>
          </AnalyticsProvider>
        </EventableAnalyticsProvider>
      </ErrorBoundary>
    </ThemeProvider>
  </Provider>
);
